import { Stack, PrimaryButton, ComboBox, IComboBoxOption, TextField, DatePicker } from '@fluentui/react';
import React from 'react';
import { TSet } from '../constants/types';
import { GetSets } from '../services/Globals';
import styles from '../styles/pokemon.module.scss';

export interface ISetManagerProps {
    dev: boolean;
    sets: TSet[];
    token: string;
    apiUrl: string;
    username: string;
    site: string;
}

export interface IsetManagerState {
    visibleTab: string;
    selectedSet?: TSet;
    sets: TSet[];
    parentSets: TSet[];
    setsComboboxOptions?: IComboBoxOption[];
    parentSetsComboboxOptions?: IComboBoxOption[];
    newSet: TSet;
    sitemap: string;
    routes: string;
};

export default class SetManager extends React.Component<ISetManagerProps, IsetManagerState> {
    constructor(props: ISetManagerProps) {
        super(props);

        this.OnSelectionClick = this.OnSelectionClick.bind(this);
        this.updateNewSet = this.updateNewSet.bind(this);
        this.addSet = this.addSet.bind(this);
        this.generate = this.generate.bind(this);

        const sets = props.sets;
        let cOptions : IComboBoxOption[] = [];
        let parentSets : TSet[] = [];
        let cParentSetsOptions : IComboBoxOption[] = [];
        sets.forEach(set => {
            if (set.parentid) {
                sets.forEach(parentSet => {
                    if (parentSet.id === set.parentid) {
                        let found = false;
                        parentSets.forEach(ps => {
                            if (ps.id === parentSet.id) {
                                found = true;
                            }
                        });
                        if (found === false) {
                            parentSets.push(parentSet);
                        } 
                    }
                });
            }
            cOptions.push({ key: set.id, text: set.name });
        });
        parentSets.forEach(parentSet => {
            cParentSetsOptions.push({key: parentSet.id, text: parentSet.name});
        });

        this.state = {newSet: {
            id: 0,
            name: '',
            accr: '',
            expansion: '',
            expansionAccr: '',
            size: 0,
            extrasize: 0,
            parentid: 0,
            scardnumber: '',
            scost: '',
            cost: 0,
            imageNames: '',
            cardcount: 0,
            defaultlwhw: '300,300,80,200',
            defaulttags: '',
        }, sitemap: "",
           routes: "", 
           sets: sets.sort((a,b) => a.id < b.id ? 1 : -1), visibleTab: "", setsComboboxOptions: cOptions, parentSets: parentSets, parentSetsComboboxOptions: cParentSetsOptions};
    }

    OnSelectionClick = (selection : string) => {
        this.setState({visibleTab: selection});
    }

    private generate(selectedSet : string) {
        // const q = `SELECT * FROM shopdb.cards INNER JOIN shopdb.sets ON shopdb.cards.setname=shopdb.sets.name where setname="${selectedSet}"`;

        // console.log(q);

        // let sitemap = "";
        // let routes = "";

        // ExecuteQuery(q,this.props.dev).then(resp => {
        //     console.log(resp);
        //     resp.forEach(row => {
        //         let snumber = "";
        //         if (row.number < 10) {
        //             snumber = "00"+row.number.toString();
        //         } else if (row.number < 100) {
        //             snumber = "0"+row.number.toString();
        //         } else {
        //             snumber = row.number.toString();
        //         }
        //         routes += `<Route path="/Pokemon kaart/${row.setname} - ${row.title} - ${snumber}/${row.size} - ${row.version}" element={<MainComponent firstComponent={ProductType.Single} />}></Route>\n`
        //         sitemap += `<url> <loc>https://pokemoncollectie.nl/Pokemon kaart/${row.setname} - ${row.title} - ${snumber}/${row.size} - ${row.version}</loc> </url>\n`;
        //     });
        //     this.setState({routes: routes, sitemap: sitemap});
        // }).catch(err => {
        //     alert(err);
        // });
    }

    private updateNewSet(prop:string, value:any) {
        let newSet = this.state.newSet;
        newSet[prop] = value;
        this.setState({newSet: newSet});
    }

    private addSet() {
        fetch(`${this.props.apiUrl}/AddSet?username=${this.props.username}&token=${this.props.token}&site=${this.props.site}`, {
            method: "Post", 
            mode: "cors", 
            headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Accept-Encoding": "gzip, deflate ,br"
            },
            referrerPolicy: "origin-when-cross-origin", 
            body: JSON.stringify(this.state.newSet), 
        }).then((response) => response.json()).then((data) => data).then((val:number) => {
            GetSets(this.props.dev).then(nsets => {
                this.updateNewSet("id",val);
                this.setState({sets:nsets});
            }).catch(err=>{
                alert(err);
            });
            alert(`Set added with id: ${val}`);
        }).catch((ex) => {
            alert(ex);
        }); 
    }

    public render(): React.ReactElement<ISetManagerProps> {
        console.log(this.state);
        return (  
            <Stack>
                <Stack style={{backgroundColor:"lightblue", width:"100%", padding:15, borderTop:"1px solid navy"}} tokens={{childrenGap: 10}} horizontal horizontalAlign='start'>
                    <h2>Set Manager</h2>
                </Stack>
                <Stack style={{backgroundColor:"lightblue", width:"100%", padding:15}} tokens={{childrenGap: 10}} horizontal horizontalAlign='start' verticalAlign='center'>
                    <PrimaryButton style={{margin:5, width:100, height:80}} text='Nieuw' onClick={() => { this.OnSelectionClick('Nieuw'); }} />

                    <PrimaryButton style={{margin:5, width:100, height:80}} text='Generate routing and sitemap' onClick={() => { this.OnSelectionClick('Generate'); }} />
                    
                    <PrimaryButton disabled style={{margin:5, width:100, height:80}} text='Upload cards' onClick={() => { this.OnSelectionClick('UploadCards'); }} />
                    
                    <PrimaryButton disabled style={{margin:5, width:100, height:80}} text='Upload images' onClick={() => { this.OnSelectionClick('UploadImages'); }} />
                    
                    <PrimaryButton disabled style={{margin:5, width:100, height:80}} text='Hide/Show' onClick={() => { this.OnSelectionClick('HideShow'); }} />
                </Stack>
                <Stack  style={{paddingLeft:10, width:"100%"}} horizontal>
                    {this.state.visibleTab === "Generate" && 
                    <Stack style={{paddingLeft:10, width:"100%"}}>
                        <h3>Genereer sitemap en routing text</h3>
                    
                        <table style={{width:"100%",height:"100%"}}>
                            <tr>
                                <td>
                                    <label>Selecteer set: </label>
                                    {this.state.setsComboboxOptions && <ComboBox options={this.state.setsComboboxOptions} onChange={(e,o) => {this.generate(o.text); }}/>}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <TextField label='Sitemap' multiline resizable rows={10} value={this.state.sitemap}/>
                                    <TextField label='Routes' multiline resizable rows={10} value={this.state.routes}/>
                                </td>
                            </tr>
                        </table>
                    </Stack>}
                    {this.state.visibleTab === "Nieuw" && 
                    <Stack  style={{paddingLeft:10}}>
                        <h3>Nieuwe set aanmaken</h3>
                        <table>
                            <tr>
                                <td>
                                    <label style={{marginRight:10}}>Parent set: </label>
                                </td>
                                <td>
                                    {this.state.parentSetsComboboxOptions && <ComboBox options={this.state.parentSetsComboboxOptions} onChange={(e,o) => {this.updateNewSet("parentid",Number(o.key));}} />}        
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label style={{marginRight:10}}>Set name: </label>
                                </td>
                                <td>
                                    <TextField onChange={(e,v) => {this.updateNewSet("name",v); }} />        
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label style={{marginRight:10}}>Release date:</label>
                                </td>
                                <td>
                                    <DatePicker onSelectDate={(d) => {this.updateNewSet("releasedate",d);}} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label style={{marginRight:10}}>Size:</label>
                                </td>
                                <td>
                                    <TextField type='number' onChange={(e,v) => {this.updateNewSet("size",Number(v)); }} />        
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label style={{marginRight:10}}>Extra size:</label>
                                </td>
                                <td>
                                    <TextField type='number' onChange={(e,v) => {this.updateNewSet("extrasize",Number(v)); }} />        
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    
                                </td>
                                <td>
                                    <PrimaryButton text='Add set' onClick={this.addSet}/>
                                </td>
                            </tr>
                        </table>
                    </Stack>}

                    {this.state.visibleTab === "UploadImages" && 
                    <Stack style={{paddingLeft:10}}>
                        <h3>Set plaatjes uploaden</h3>
                    
                        <table>
                            <tr>
                                <td>
                                    <label>Selecteer set: </label>
                                </td>
                                <td>
                                    {this.state.setsComboboxOptions && <ComboBox options={this.state.setsComboboxOptions} />}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label style={{marginRight:10}}>Logo:</label>
                                </td>
                                <td>
                                    <input type="file" accept=".webp" />
                                </td>
                            </tr>
                        </table>
                    
                    </Stack>}

                    {this.state.visibleTab === "UploadCards" && 
                    <Stack style={{paddingLeft:10}}>
                        <h3>Set kaarten uploaden</h3>
                        
                        <table>
                            <tr>
                                <td>
                                    <label>Selecteer set: </label>
                                </td>
                                <td>
                                    {this.state.setsComboboxOptions && <ComboBox options={this.state.setsComboboxOptions} />}
                                </td>
                            </tr>
                        </table>
                        
                    </Stack>}

                    {this.state.visibleTab === "HideShow" && 
                    <Stack style={{paddingLeft:10}}>
                        <h3>Set verbergen/tonen</h3>
                        <table>
                            <tr>
                                <td>
                                    <label>Selecteer set: </label>
                                </td>
                                <td>
                                    {this.state.setsComboboxOptions && <ComboBox options={this.state.setsComboboxOptions} />}
                                </td>
                            </tr>
                        </table>
                    </Stack>}
                </Stack>
            </Stack> 
        );
    }
}